import { combineReducers } from 'redux'
import oidcReducer from './oidcReducer'

import { reducer as balanceReducer } from 'features/Balance'
import { reducer as searchReducer } from 'App/Header/Search'
import { reducer as cartReducer } from 'features/Cart'
import { reducerItemToRemove } from 'Checkout'

import {
  mainMenuReducer,
  productCategoriesReducer,
  storesReducer,
  onlyCashReducer
} from 'App/MainMenu'

import { productSuggestionReducer } from '../features/Suggestion/ProductSuggestion'
import { recomendationReducer } from '../features/Recomendation'
import { voucherSuggestionReducer } from '../features/Suggestion/VoucherSuggestion'
import { storeSuggestionReducer } from '../features/Suggestion/StoreSuggestion'
import { ShippingReducer } from 'Catalog/Product/ProductDetail/RedemptionSection/Shipping'
import { unAvailableReducer } from 'Catalog/Product/ProductDetail/RedemptionSection/Unvailable'
import { reducer as productDetailReducer } from 'Catalog/Product/ProductDetail'
import { paymentReducer } from 'Catalog/Product/ProductDetail/RedemptionSection/Payment'

import { reducer as addressReducer } from '../features/Address'
import searchPageReducer from 'Catalog/Search/ducks'
import { reducer as cardBrandsReducer } from '../features/CardBrands'

import { reducer as regulationReducer } from '../features/Regulation'
import { reducer as myOrdersReducer } from 'Participant/MyOrders'
import { reducer as wishlistReducer } from 'Participant/Wishlist'
import { reducer as mobileOperatorsReducer } from 'features/SelectMobileOperator'
import { reducer as valuesRechargeReducer } from 'features/CellphoneRecharge/ValuesRecharge'
import { reducer as selectAreaCodeReducer } from 'features/CellphoneRecharge/PhoneNumber/SelectAreaCode'
import { reducer as extractReducer } from 'Participant/Extract'
import { reducer as cellphoneRechargeReducer } from 'features/CellphoneRecharge'
import { reducer as confirmationReducer } from 'features/Confirmation'
import { reducer as confirmationMobileRechargeScheduleReducer } from 'features/ConfirmationMobileRechargeSchedule'
import { reducer as schedulingReducer } from 'Participant/Scheduling'
import { reducer as fuelCreditReducer } from 'features/Services/FuelCredit'
import { reducer as confirmationCreditMileageReducer } from 'features/Services/ConfirmationCreditMileage'
import { reducer as mileageReducer } from 'features/Services/Mileage'
import { reducer as trackingReducer } from 'App/Header/Tracking'
import { reducer as stixReducer } from 'features/Stix'

import { productReducer } from '../features/Products/reducer'

import { reducer as checkoutReducer } from '../features/Checkout'

import participantReducer from 'Participant/ducks'
import regulationsModal from '../features/RegulationModal/ducks'
import availableVendorsReducer from 'Participant/MyOrders/ProductOrderDetail/ProductSide/reducer'
import catalogReducer from 'Catalog/ducks'
import brandReducer from 'Catalog/Brand/ducks'
import vendorReducer from 'Catalog/Vendor/ducks'
import availabilityReducer from 'Catalog/Availability/ducks'
import showcaseReducer from 'Catalog/Showcase/ducks'
import servicesReducer from 'Catalog/Service/ducks'
import productsReducer from 'Catalog/Product/ducks'
import wishlistv2Reducer from 'Wishlist/ducks'
import metadataReducer from 'Shared/HeadMetadata/ducks'
import pointsPurchaseReducer from 'Checkout/PointsPurchase/ducks'
import tokenChangeEmailReducer from 'Participant/TokenChangeEmail/ducks'
import creditCardInvoiceDiscoutReducer from 'features/InvoiceCredit/ducks'
import likePlusReducer from 'features/LikePlus/ducks'

import changeUraPasswordReducer from 'Participant/UraPassword/ChangeUraPassword/ducks'

const google = (state = { google: {} }, action) => ({
  ...state
})

const rootReducer = combineReducers({
  availableVendors: availableVendorsReducer,
  onlyCash: onlyCashReducer,
  oidc: oidcReducer,
  productSuggestion: productSuggestionReducer,
  recomendation: recomendationReducer,
  voucherSuggestion: voucherSuggestionReducer,
  storeSuggestion: storeSuggestionReducer,
  balance: balanceReducer,
  cart: cartReducer,
  itemsToRemove: reducerItemToRemove,
  mainMenu: mainMenuReducer,
  shipping: ShippingReducer,
  unAvailable: unAvailableReducer,
  productsBySku: productDetailReducer,
  payment: paymentReducer,
  address: addressReducer,
  autoComplete: searchReducer,
  searchResult: searchPageReducer,
  google: google,
  productCategories: productCategoriesReducer,
  stores: storesReducer,
  cardBrands: cardBrandsReducer,
  regulations: regulationReducer,
  regulationsModal: regulationsModal,
  myOrders: myOrdersReducer,
  mobileOperators: mobileOperatorsReducer,
  valuesRecharge: valuesRechargeReducer,
  areaCodes: selectAreaCodeReducer,
  extract: extractReducer,
  checkout: checkoutReducer,
  cellphoneRecharge: cellphoneRechargeReducer,
  confirmation: confirmationReducer,
  confirmationMobileRechargeSchedule: confirmationMobileRechargeScheduleReducer,
  scheduling: schedulingReducer,
  products: productReducer,
  fuelCredit: fuelCreditReducer,
  confirmationCreditMileage: confirmationCreditMileageReducer,
  mileage: mileageReducer,
  ordersTracking: trackingReducer,
  wishlist: wishlistReducer,
  participant: participantReducer,
  catalog: catalogReducer,
  showcases: showcaseReducer,
  services: servicesReducer,
  productsv2: productsReducer,
  availability: availabilityReducer,
  wishlistv2: wishlistv2Reducer,
  metadata: metadataReducer,
  brands: brandReducer,
  vendors: vendorReducer,
  pointsPurchase: pointsPurchaseReducer,
  tokenChangeEmail: tokenChangeEmailReducer,
  changeUraPassword: changeUraPasswordReducer,
  stix: stixReducer,
  invoiceCredit: creditCardInvoiceDiscoutReducer,
  likeplus: likePlusReducer
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/redux/rootReducer.js